// Drop events from automated clients (uptime checks, crawlers, scanners,
// Lighthouse runs). These hit `/` and trip module-loading errors that real
// users never see, but still consume our error/replay quota.
//
// Notes on regex shape:
// - Brand strings (`HeadlessChrome`, `Googlebot`, `Pingdom`, etc.) are
//   specific enough to match as-is without word boundaries.
// - The generic terms `crawler` and `spider` are word-boundary anchored
//   (`\b`) so a UA containing e.g. "ScalaCommander" or "OpenSpiderMonkey"
//   does not falsely match.
// - `monitoring` (broad, prone to false positives from corporate/managed-
//   browser UAs that inject "monitoring" into the agent string) was
//   intentionally replaced with the more specific `monitoring-bot` /
//   `Site24x7` brand patterns.
const BOT_UA_PATTERN =
  /HeadlessChrome|HeadlessFirefox|PhantomJS|Lighthouse|Googlebot|bingbot|YandexBot|DuckDuckBot|Baiduspider|Pingdom|UptimeRobot|StatusCake|Site24x7|monitoring-bot|\bcrawler\b|\bspider\b/i

export const isBotUserAgent = (ua?: string): boolean => {
  if (!ua) return false
  return BOT_UA_PATTERN.test(ua)
}
